export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '발생일시' }, { name: '사고장소' }, { name: '작성부서' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).inputB_5 // 발생일시
      case 2: return func.getContent(value).inputB_4 // 사고장소
      case 3: return func.getContent(value).stdInfo.section // 작성부서
      case 4: return func.getContent(value).stdInfo.writer_name // 작성자
      case 5: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    switch (nav.value.searchType) {
    case '사업장명': return ['content$body.stdInfo.field_name*%[:default_skw]%']
    case '발생일시': return ['content$body.inputB_5*%[:default_skw]%']
    case '사고장소': return ['content$body.inputB_4*%[:default_skw]%']
    case '작성부서': return ['content$body.stdInfo.section*%[:default_skw]%']
    case '작성자': return ['content$body.stdInfo.writer_name*%[:default_skw]%']
    }

    return []
  },
}
